import React from 'react';
import { Link } from 'gatsby';
import { AnimatePresence } from 'framer-motion';
import {
  TabPanelBlock,
  TabPanel,
  EventUL,
  GettingHereLink,
  ListTab,
} from './styles/BannerAsideTabBlock.styled';
import MetroIcon from '../assets/svg/metrow.svg';
import BusIcon from '../assets/svg/ico-bus.svg';
import ParkingIcon from '../assets/svg/parkingw.svg';
import CareemIcon from '../assets/svg/careemicon.svg';
import UberIcon from '../assets/svg/ubericon.svg';

export default function AsideMenuGettingHere({ isVisible, lang, dir }) {
  const isArabic = lang === 'ar';
  const variants = {
    isOpen: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.3,
        ease: 'linear',
      },
    },
    isClosed: {
      opacity: 0,
      x: 300,
      transition: {
        duration: 0.3,
        ease: 'linear',
      },
    },
  };

  return (
    isVisible && (
      <AnimatePresence>
        <TabPanelBlock variants={variants} initial="isClosed" animate="isOpen" exit="isClosed">
          <TabPanel dir={dir}>
            <EventUL>
              <h5>{isArabic ? 'الوصول إلينا' : 'Getting Here'}</h5>
              <ListTab className="transport" dir={dir}>
                <GettingHereLink className="t-icon icon-1" to={`/${lang}/getting-here#dubai-metro`}>
                  <MetroIcon />
                </GettingHereLink>
                <GettingHereLink className="t-icon icon-2" to={`/${lang}/getting-here#dubai-taxi`}>
                  <BusIcon />
                </GettingHereLink>
                <p>{isArabic ? 'وسائل النقل العامة' : 'Public Transportation'}</p>
              </ListTab>
              <Link to={`/${lang}/getting-here#driving-and-parking`}>
                <ListTab className="drvparking" dir={dir}>
                  <GettingHereLink className="dp-icon">
                    <ParkingIcon />
                  </GettingHereLink>
                  <p dir={dir}>{isArabic ? 'القيادة والمواقف' : 'Driving and Parking'}</p>
                </ListTab>
              </Link>
              <ListTab className="taxiservice">
                <GettingHereLink
                  className="ts-icon icon-1"
                  to={`/${lang}/getting-here#private-taxi`}
                >
                  <CareemIcon />
                </GettingHereLink>
                <GettingHereLink
                  className="ts-icon icon-2"
                  to={`/${lang}/getting-here#private-taxi`}
                >
                  <UberIcon />
                </GettingHereLink>
              </ListTab>
            </EventUL>
          </TabPanel>
        </TabPanelBlock>
      </AnimatePresence>
    )
  );
}
